import SubmissionError from '../../../error/SubmissionError';
import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  TRANSFERTYPE_CREATE_ERROR,
  TRANSFERTYPE_CREATE_LOADING,
  TRANSFERTYPE_CREATE_SUCCESS,
  TRANSFERTYPE_CREATE_VIOLATIONS,
  TRANSFERTYPE_CREATE_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  created: null,
  violations: {}
};

function error(error) {
  return {type: TRANSFERTYPE_CREATE_ERROR, error};
}

function loading(loading) {
  return {type: TRANSFERTYPE_CREATE_LOADING, loading};
}

function success(created) {
  return {type: TRANSFERTYPE_CREATE_SUCCESS, created};
}

function violations(violations) {
  return {type: TRANSFERTYPE_CREATE_VIOLATIONS, violations};
}

function reset() {
  return {type: TRANSFERTYPE_CREATE_RESET};
}

const getters = {
  created: state => state.created,
  error: state => state.error,
  loading: state => state.loading,
  violations: state => state.violations,
};

const actions = {
  create({ commit }, values) {
    commit(loading(true));
    commit(violations({}));
    commit(error(null));
    if(typeof values.amount == 'string'){
      values.amount = values.amount.replace(',','.').replace(' ','');
    }
    values.amount = parseFloat(values.amount);
    return http.fetch('/transfer_types', {method: 'POST', body: JSON.stringify(values)})
      .then(response => {
        commit(loading(false));

        return response.json();
      })
      .then(data => {
        commit(success(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors));
          return;
        }
        commit(error(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [TRANSFERTYPE_CREATE_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [TRANSFERTYPE_CREATE_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [TRANSFERTYPE_CREATE_SUCCESS] (state, payload) {
      state.created = payload.created;
    },
    [TRANSFERTYPE_CREATE_VIOLATIONS] (state, payload) {
      state.violations = payload.violations;
    },
    [TRANSFERTYPE_CREATE_RESET] (state) {
      state.loading = false;
      state.error = '';
      state.created = null;
      state.violations = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/transfertype/create.js